module.exports = __webpack_public_path__ + "static/img/bg.4dfb0ce9.png";